import { config } from './config.js';
import type { Config } from './types.js';

/**
 * Hook to retrieve the application configuration. This hook is wholly unnecessary as the
 * configuration is a singleton, but React developers love their hooks.
 *
 * @returns Application configuration.
 */
export const useConfig = (): Config => config;
